import {
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_META_DATA, MUTATION_SET_LOCAL_META_DATA,
} from '@/store/checkout';

/** В отличие от checkoutFormStep может использоваться не только в шагах но и в любом месте */
export default {
	computed: {
		priceData() {
			const data = this.$store.getters['checkout/getPriceData'](this.formData.id);
			if (typeof data === 'undefined') {
				return {
					promocode: null,
					amount: null,
					price: null,
					basePrice: null,
					discountAmount: null,
					personCount: null,
					individualPrice: null,
					studentIndividualPrice: null,
					individualPriceWithDiscount: null,
					studentIndividualPriceWithDiscount: null,
				};
			}

			return data;
		},
		isInvoicePayment() {
			return this.$store.state.checkout.formsData.localMeta?.[this.formData.id].isInvoicePayment;
		},
	},
	methods: {
		setLocalIsInvoicePayment(value) {
			this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
				formId: this.formData.id,
				localMeta: {
					isInvoicePayment: value,
				},
			});
		},
		setContactManager(contactManagerReason = null) {
			this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`, {
				meta: {
					isContactManager: true,
					contactManagerReason,
				},
				formId: this.formData.id,
			});

			this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
				formId: this.formData.id,
				localMeta: {
					isShowDocumentInfoMessage: false,
				},
			});

			this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`, {
				formId: this.formData.id,
			});
		},
		fieldsByScenario(step, scenario) {
			const fields = {};

			if (!this.formData.fields[step]) {
				return fields;
			}

			Object.keys(this.formData.fields[step]).forEach((fieldName) => {
				if (
					this.formData.fields[step][fieldName].scenario === scenario
					|| this.formData.fields[step][fieldName].scenario === 3
					|| this.formData.fields[step][fieldName].scenario === null
				) {
					fields[fieldName] = this.formData.fields[step][fieldName];
				}
			});

			return fields;
		},
	},
};
